import PhoneIcon from '@material-ui/icons/PhoneIphone';
import styled from 'styled-components';

import THEME from '../../constants/theme';

export const PhoneInputContainer = styled.div`
  position: relative;
  margin: 28px 0 4px;

  && > div > span:first-child {
    color: ${({ error }) => (error ? THEME.error : THEME.primary)};
  }

  && .PhoneInputInput {
    color: ${THEME.muiText};
    opacity: 1;
    font-size: 14px;
    font-family: "Montserrat", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.42857;
    border-color: ${({ error }) => (error ? THEME.error : THEME.muiBorderGrey)};
  }

  && .PhoneInputInput:focus {
    border-color: ${props => (props.error ? `${THEME.error}` : `${THEME.primary}`)};
  }

  && .PhoneInputInput::placeholder {
    color: ${props => (props.error ? `${THEME.error}` : `${THEME.muiGrey}`)};
  }

  && .PhoneInput + span {
    padding-left: 0;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
  }
`;

PhoneInputContainer.displayName = 'PhoneContainer';

export const PhoneInputIcon = styled(PhoneIcon)`
  position: absolute;
  top: 0;
  right: 0;
  color: ${THEME.muiText}
`;
